<template>
  <div class="container">
    <template v-if="checkWidth >= 1039">
      <template v-for="item in content">
        <CRow
          class="mb-3"
          :key="item._id"
          align-vertical="start"
          v-if="item.position === 0 || item.position === 'left'"
        >
          <CCol xl="1" lg="1" md="1" sm="1">
            <img
              :src="baseUrl + item.image"
              style="width: 70px; height: 70px"
            />
          </CCol>
          <CCol xl="7" lg="7" md="7" sm="7" style="margin-left: 3%">
            <div
              class="talk-bubble-gray-audio tri-right round left-in"
              @click="playSound(item)"
            >
              <div class="talktext">
                <p :class="checkLangClass() + ' ' + 'chat-textAudio'">
                  {{ checkLanguage(item.message) }}
                </p>
              </div>
            </div>
            <div class="containerSmallAudioLeft" @click="playSound(item)">
              <font-awesome-icon
                class="SmallAudio"
                icon="volume-up"
              ></font-awesome-icon>
            </div>
          </CCol>
        </CRow>

        <CRow
          :key="item.id"
          align-vertical="start"
          align-horizontal="end"
          class="mr-0 mb-3"
          v-if="item.position === 1 || item.position === 'right'"
        >
          <CCol
            :xl="{size: '7', offset: '3'}"
            :lg="{size: '7', offset: '3'}"
            :md="{size: '7', offset: '3'}"
            :sm="{size: '7', offset: '3'}"
            style="display: flex; justify-content: flex-end"
          >
            <div
              class="talk-bubble-blue-audio tri-right round right-in"
              @click="playSound(item)"
            >
              <div class="talktext">
                <p :class="checkLangClass() + ' ' + 'chat-textAudio'">
                  {{ checkLanguage(item.message) }}
                </p>
              </div>
            </div>
            <div class="containerSmallAudioRight" @click="playSound(item)">
              <font-awesome-icon
                class="SmallAudio"
                icon="volume-up"
              ></font-awesome-icon>
            </div>
          </CCol>
          <CCol
            xl="1"
            lg="1"
            md="1"
            sm="1"
            class="rightConver"
            style="text-align: center"
          >
            <img
              :src="baseUrl + item.image"
              style="width: 70px; height: 70px"
            />
          </CCol>
        </CRow>
      </template>
    </template>
    <template v-if="checkWidth <= 1038 && checkWidth > 500">
      <template v-for="item in content">
        <CRow
          class="mb-3"
          :key="item._id"
          align-vertical="start"
          v-if="item.position === 0 || item.position === 'left'"
        >
          <CCol xl="1" lg="2" md="2" sm="2">
            <img
              :src="baseUrl + item.image"
              style="width: 70px; height: 70px"
            />
          </CCol>
          <CCol xl="7" lg="7" md="7" sm="7" style="margin-left: 3%">
            <div
              class="talk-bubble-gray-audio tri-right round left-in"
              @click="playSound(item)"
            >
              <!-- {{item.button.url}} -->
              <div class="talktext">
                <p :class="checkLangClass() + ' ' + 'chat-textAudio'">
                  {{ checkLanguage(item.message) }}
                </p>
              </div>
            </div>
            <div class="containerSmallAudioLeft" @click="playSound(item)">
              <font-awesome-icon
                class="SmallAudio"
                icon="volume-up"
              ></font-awesome-icon>
            </div>
          </CCol>
        </CRow>

        <CRow
          :key="item.id"
          align-vertical="start"
          align-horizontal="end"
          class="mr-0 mb-3"
          v-if="item.position === 1 || item.position === 'right'"
        >
          <CCol
            :xl="{size: '7', offset: '3'}"
            :lg="{size: '7', offset: '3'}"
            :md="{size: '7', offset: '3'}"
            :sm="{size: '7', offset: '3'}"
            style="display: flex; justify-content: flex-end"
          >
            <div
              class="talk-bubble-blue-audio tri-right round right-in"
              @click="playSound(item)"
            >
              <div class="talktext">
                <p :class="checkLangClass() + ' ' + 'chat-textAudio'">
                  {{ checkLanguage(item.message) }}
                </p>
              </div>
            </div>
            <div class="containerSmallAudioRight" @click="playSound(item)">
              <font-awesome-icon
                class="SmallAudio"
                icon="volume-up"
              ></font-awesome-icon>
            </div>
          </CCol>
          <CCol
            xl="1"
            lg="2"
            md="2"
            sm="2"
            class="rightConver"
            style="text-align: center"
          >
            <img
              :src="baseUrl + item.image"
              style="width: 70px; height: 70px"
            />
          </CCol>
        </CRow>
      </template>
    </template>
    <template v-if="checkWidth <= 500">
      <template v-for="item in content">
        <CRow
          class="mb-3"
          :key="item._id"
          align-vertical="start"
          v-if="item.position === 0 || item.position === 'left'"
        >
          <CCol col="4">
            <img
              :src="baseUrl + item.image"
              style="width: 70px; height: 70px"
            />
          </CCol>
          <CCol col="8">
            <div
              class="talk-bubble-gray-audio tri-right round left-in"
              @click="playSound(item)"
            >
              <!-- {{item.button.url}} -->
              <div class="talktext">
                <p :class="checkLangClass() + ' ' + 'chat-textAudio'">
                  {{ checkLanguage(item.message) }}
                </p>
              </div>
            </div>
            <div class="containerSmallAudioLeft" @click="playSound(item)">
              <font-awesome-icon
                class="SmallAudio"
                icon="volume-up"
              ></font-awesome-icon>
            </div>
          </CCol>
        </CRow>

        <CRow
          :key="item.id"
          align-vertical="start"
          align-horizontal="end"
          class="mr-0 mb-3"
          v-if="item.position === 1 || item.position === 'right'"
        >
          <CCol col="8" style="display: flex; justify-content: flex-end">
            <div
              class="talk-bubble-blue-audio tri-right round right-in"
              @click="playSound(item)"
            >
              <div class="talktext">
                <p :class="checkLangClass() + ' ' + 'chat-textAudio'">
                  {{ checkLanguage(item.message) }}
                </p>
              </div>
            </div>
            <div class="containerSmallAudioRight" @click="playSound(item)">
              <font-awesome-icon
                class="SmallAudio"
                icon="volume-up"
              ></font-awesome-icon>
            </div>
          </CCol>
          <CCol col="4" class="rightConver" style="text-align: center">
            <img
              :src="baseUrl + item.image"
              style="width: 70px; height: 70px"
            />
          </CCol>
        </CRow>
      </template>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import '../../../assets/css/chatBubble.css';

export default {
  components: {},
  name: 'ChatAudio',
  props: {
    content: Array,
    checkWidth: Number,
  },
  data() {
    return {
      lang: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
    };
  },
  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
    }),
  },
  watch: {
    storeLanguage: function (val) {
      this.lang = val;
    },
  },

  mounted() {
    this.lang = this.$store.state.language.language;
  },

  created() {},

  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i]?.key == this.lang) {
            return val[i].value;
          }
        }
      } else {
        console.log('change language is error!!');
      }
    },
    playSound(sound) {
      if (sound) {
        var audio = new Audio(this.baseUrl + '' + sound.button.data);
        audio.play();
      }
    },
  },
};
</script>

<style scoped>
.imgTest {
  width: 100%;
  height: 100%;
  margin-bottom: 7px;
}

.ConverUser {
  width: 4rem;
  height: 4rem;
  border-radius: 60px;
  border-color: black;
  border: 2px solid;
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-message {
  width: fit-content;
  height: 100%;
  border-radius: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: lightgray;
  color: black;
  /* margin-left: auto; */
  /* margin-right: auto; */
  /* background-color: black; */
}

.right-message {
  width: fit-content;
  height: 100%;
  border-radius: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2c8dfb;
  color: white;
  margin-left: auto;
  /* background-color: black; */
}

.rightConver {
  width: 100%;
  display: flex;
  justify-content: flex-end !important;
  /* margin-top: 2%; */
}

.Left-convo {
  justify-content: flex-start;
  margin-bottom: 2%;
}
.containerSmallAudioLeft {
  cursor: pointer;
  width: 30px;
  height: 30px;
  background-color: #457ae6;
  border: 3px solid;
  border-color: white;
  border-radius: 60px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 99;
  /* right: auto; */
  top: -85px;
}
.containerSmallAudioRight {
  cursor: pointer;
  width: 30px;
  height: 30px;
  background-color: #457ae6;
  border: 3px solid;
  border-color: white;
  border-radius: 60px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 99;
  right: 20px;
  top: -10px;
}
</style>
